// React
import React, { useState, useEffect, useMemo } from "react";

// Ionic
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonAlert,
} from "@ionic/react";

import { scanOutline } from "ionicons/icons";

/*import { useLocation } from 'react-router-dom';*/

// Components

import Constants from "../Context/constants";

/*** Search ***/
import Map from "../components/Map/Map";
import Markerroute from "../components/Map/MarkerRoute";
//CSS

// Packages
import { Wrapper } from "@googlemaps/react-wrapper";

// Data
import UserService from "../Context/user.service";
import { fetchMinimalDataWithFilter, isFilterSet, findAndFetchRouteMarkers } from "../Context/filter.service";

//CSS
import RouteSearch from "../components/Route/Route-search";
import InfoCard from "../components/Search/InfoCard";
import Filter from "../components/Route/Filter";
import ModalBookmark from "../Context/bookmark.modal";

const render = (status) => {
  return <h1>{status}</h1>;
};

window.allRouteMarker = [];

// Function Component Export
function Route(props) {

  const [activeFilter, setActiveFilter] = useState(Constants.routeDefaultValueFilter);
  const [filterLoaded, setFilterLoaded] = useState(false);

  // Load filter from localStorage on component mount
  useEffect(() => {
    const storedFilter = localStorage.getItem("ba-route-filter");
    if (storedFilter) {
      try {
        const prefilter = JSON.parse(storedFilter);
        setActiveFilter(prefilter);
      } catch (error) {
        //console.error("Error parsing stored filter:", error);
        setActiveFilter(Constants.routeDefaultValueFilter);
      }
    }
    setFilterLoaded(true);
  }, []);

  // Save filter to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("ba-route-filter", JSON.stringify(activeFilter));
  }, [activeFilter]);

  function filterIsSet() {
    return isFilterSet(activeFilter, Constants.routeDefaultValueFilter);
  }

  const interestsCat = [];
  const initialRendered = false;
  const fireSearch = false;
  const [loading, setLoading] = useState(false);
  
  if (Constants.interests) {
    for (const key in Constants.interests) {
      interestsCat.push(key);
    }
  }

  var defaultmode = "customroute";
  var iddef = 0;

  var testurl = window.location.href.split("/route");
  if (testurl[1] !== "" && testurl[1] !== "/") {
    defaultmode = "bookmarkroute";
    var geturl = window.location.href.split("/route/");
    iddef = geturl[1];
    if (iddef.indexOf("sso_session") !== -1) {
      var temp = iddef.split("?sso_session");
      iddef = temp[0];
      if (iddef === "/" || iddef === "") {
        defaultmode = "customroute";
      }
    }

    if (
      typeof window.parent.seturl !== "undefined" &&
      typeof iddef !== "undefined"
    ) {
      window.parent.seturl("route", iddef);
    }
  }

  var userInitial = 1;
  var logedInInitial = false;
  var isProinitial = false;
  var tokenInitial = "";

  const tokenData = UserService.getUserData();
  if (tokenData && tokenData["tokenData"] && typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
    userInitial = tokenData["tokenData"].MerchantCustomerId;
    logedInInitial = true;

    if (tokenData.login == 1) {
      logedInInitial = true;
    }
    if (tokenData.pro == 1) {
      isProinitial = true;
    }
    tokenInitial = tokenData.cookie || "";
  }

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPro, setIsPro] = useState(isProinitial);
  const [isLoggedIn, setIsLoggedIn] = useState(logedInInitial);
  const [user, setUser] = useState(userInitial);
  const [token, setToken] = useState(tokenInitial);
  const [allbookmarks, setAllBookmarks] = useState([]);
  const [searchType, setSearchType] = useState("");
  const [profileInterests, setProfileInterests] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [zoom, setZoom] = useState(9); // initial zoom
  const [mapTypeId, setmapTypeId] = useState("roadmap"); // initial zoom
  const [items, setItems] = useState([]);
  const [mode, setMode] = useState(defaultmode);
  const [id, setId] = useState(iddef);
  const [minimalData, setMinimalData] = useState([]);
  const [bookmark, setbookmark] = useState([]);
  const [currentRoutePoints, setCurrentRoutePoints] = useState(null); // Track current route for recalculation
  const [initialDataLoaded, setInitialDataLoaded] = useState(false); // Track if initial minimal data has been loaded

  // Filter states
  const [dog, setDog] = useState(false);
  const [disposal, setDisposal] = useState(false);
  const [forfree, setForfree] = useState(false);
  const [showNoResultsAlert, setShowNoResultsAlert] = useState(false);
  const [showNoResults, setShowNoResults] = useState(false);

  const sendSearch = function () {
    /*
    setTimeout(function () {
      handleSearchSubmit();
    }, 150);
    */
  };


  
  

  const [center, setCenter] = useState({
    lat: 51.125732475473455,
    lng: 10.099784125401262,
  });

  // Memoize the center to prevent unnecessary map recentering on filter changes
  const stableCenter = useMemo(() => center, [center.lat, center.lng]);

  // Memoize map props to prevent unnecessary re-renders
  const mapProps = useMemo(() => ({
    id: "mainmap",
    center: stableCenter,
    onClick,
    onIdle,
    onLoad,
    zoom,
    style: { flexGrow: "1", height: "100%" },
    mapTypeId
  }), [stableCenter, onClick, onIdle, onLoad, zoom, mapTypeId]);

  const pid = user;

  /*************************  MAPS HANDLERS ************************* */
  const onClick = (e) => {
    // avoid directly mutating state
    setMarkers([...markers, e.latLng]);
  };

  const onLoad = function (m) {};

  const onIdle = (m) => {};

  const setMapCenter2 = (items) => {
    var bounds = new window.google.maps.LatLngBounds();
    items.forEach((item) => {
      var cords = new window.google.maps.LatLng(
        item.gps.latitude,
        item.gps.longitude
      );
      bounds.extend(cords);
    });
    window.gmap.fitBounds(bounds);

    if (items.length == 1) {
      setCenter(window.gmap.getCenter());
    }
  };

  if (
    typeof window.parent.seturl !== "undefined" &&
    window.self.location.href.indexOf("home") !== -1
  ) {
    setTimeout(function () {
      window.parent.seturl("search", "");
    }, 350);
  }

  function renderRoute(response, type) {
    //setMapCenter(response.data);

    var max = response.data.length - 1;

    if (
      typeof window.directionsRenderer !== "undefined" &&
      window.directionsRenderer !== null
    ) {
      window.directionsRenderer.setMap(null);
    }

    var directionsService = new window.google.maps.DirectionsService();
    var directionsRenderer = new window.google.maps.DirectionsRenderer({
      suppressMarkers: true,
    });
    var waypts = [];
    var start = new window.google.maps.LatLng(
      response.data[0].gps.latitude,
      response.data[0].gps.longitude
    );
    var end = new window.google.maps.LatLng(
      response.data[max].gps.latitude,
      response.data[max].gps.longitude
    );

    window.directionsRenderer = directionsRenderer;

    directionsRenderer.setMap(window.gmap);

    if (max > 1) {
      response.data.forEach((item, index) => {
        if (
          index !== 0 &&
          index !== max &&
          typeof response.data[index].gps !== "undefined"
        ) {
          waypts.push({
            location: new window.google.maps.LatLng(
              response.data[index].gps.latitude,
              response.data[index].gps.longitude
            ),
            stopover: true,
          });
        }
      });
    }

    var request = {
      origin: start,
      destination: end,
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: "DRIVING",
    };
    directionsService.route(request, function (response, status) {
      var markersitems = [];
      var markersinside = [];

      if (status == "OK") {
        if (mode === "customroute") {
          var idstocatch = [];
          
          // Store route points for potential recalculation when filters change
          setCurrentRoutePoints(response.routes[0].overview_path);

          /*start*/
          markersitems.push({
            id: "start",
            stellplatzname: "Start",
            stellplatztyp: "start",
            gps: {
              latitude: start.lat,
              longitude: start.lng,
            },
          });
          /*end*/
          markersitems.push({
            id: "destination",
            stellplatzname: "Ziel",
            stellplatztyp: "destination",
            gps: {
              latitude: end.lat,
              longitude: end.lng,
            },
          });

          var nearbys = [];

          findAndFetchRouteMarkers(
            response.routes[0].overview_path,
            minimalData,
            15,
            (fetchedItems) => {
              if(fetchedItems.length==0){
                setShowNoResults(false);
                setShowNoResultsAlert(true);
                // Reset filter UI states
                setDog(false);
                setDisposal(false);
                setForfree(false);
                // Reset filters to default
                setActiveFilter(Constants.routeDefaultValueFilter);
                // Re-fetch minimal data with default filter
                fetchMinimalDataWithFilter(
                  Constants.routeDefaultValueFilter,
                  Constants.routeDefaultValueFilter,
                  (resetMinData) => {
                    setMinimalData(resetMinData.data);
                    window.minData = resetMinData.data;
                    // Re-search with reset filter
                    findAndFetchRouteMarkers(
                      response.routes[0].overview_path,
                      resetMinData.data,
                      15,
                      (resetFetchedItems) => {
                        setItems(resetFetchedItems);
                        setTimeout(function () {
                          setMapCenter2(resetFetchedItems);
                        }, 350);
                      },
                      (resetError) => {
                        //console.log("Error fetching reset route markers:", resetError);
                      }
                    );
                  },
                  (resetError) => {
                    //console.log("Error fetching reset minimal data:", resetError);
                  }
                );
              } else {
                setShowNoResults(false);
                setItems(fetchedItems);
                setTimeout(function () {
                  setMapCenter2(fetchedItems);
                }, 350);
              }
            },
            (error) => {
              //console.log("Error fetching route markers:", error);
            }
          );
        }
        directionsRenderer.setDirections(response);
      }
    });
    if (mode === "customroute") {
    } else {
      setItems(response.data);
    }
  }

  const calcDistance = function (lat1, lat2, lon1, lon2) {
    lat1 = (lat1 * Math.PI) / 180;
    lat2 = (lat2 * Math.PI) / 180;
    lon1 = (lon1 * Math.PI) / 180;
    lon2 = (lon2 * Math.PI) / 180;
    var R = 6371; // km
    var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    var y = lat2 - lat1;
    var d = Math.sqrt(x * x + y * y) * R;
    return d;
  };

  const getCustomRoute = function (from, to) {
    UserService.getCustomRouteContent(from, to, token).then(
      (response) => {
        if (typeof response.data["error"] !== "undefined") {
          alert(response.data["error"]);
        } else {
          setIsLoaded(true);
          setTimeout(function () {
            renderRoute(response, "custom");
          }, 150);
        }
      },
      (error) => {
        setError(error);
      }
    );
  };

  /*************************  GET PREVIOUS SEARCH + BOOMARK + FILTER DATA ON LOAD************************* */
  useEffect(() => {

    UserService.getProfileFields(user, token).then((response) => {
      setProfileInterests(response.data[0].interests);
    });
    

    UserService.getBookmarks(pid, token).then(
        (response) => {
          setbookmark(response.data);

          var allb = [];
          response.data.lists.forEach((list) => {
            list.items.forEach((item) => {
              if (typeof item === "number") {
                allb.push(item);
              }
            });
          });

          setAllBookmarks(allb);
        },
        (error) => {
          setError(error);
        }
    );

    if (mode === "bookmarkroute") {
      UserService.getRouteContent(id, pid, token).then(
        (response) => {
          setIsLoaded(true);
          setTimeout(function () {
            renderRoute(response, "bookmarks");
          }, 150);
        },
        (error) => {
          setError(error);
        }
      );
    } else {
      setIsLoaded(true);
    }
  }, []);

  // Load initial minimal data after filter has been loaded from localStorage
  useEffect(() => {
    if (filterLoaded && mode !== "bookmarkroute") {
      fetchMinimalDataWithFilter(
        activeFilter,
        Constants.routeDefaultValueFilter,
        (minData) => {
          setMinimalData(minData.data);
          window.minData = minData.data;
          setInitialDataLoaded(true);
        },
        (error) => {
          //console.log(error);
          setInitialDataLoaded(true);
        }
      );
    }
  }, [filterLoaded, mode]);

  // Separate useEffect for loading minimal data when activeFilter changes (after initial load)
  /*
  useEffect(() => {
    if (mode !== "bookmarkroute" && initialDataLoaded) {
      fetchMinimalDataWithFilter(
        activeFilter,
        Constants.routeDefaultValueFilter,
        (minData) => {
          setMinimalData(minData.data);
          window.minData = minData.data;
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }, [activeFilter, mode, initialDataLoaded]);
  */

  if (isLoaded && !isPro) {
    if (typeof window.parent.setPaywallModal !== "undefined") {
      window.parent.setPaywallModal("pro");
    }
    return (
      <>
        <IonRow size="12" className="ion-justify-content-center">
          <h2>Routenplanung</h2>
        </IonRow>
        <IonRow size="12" className="ion-justify-content-center">
          <p> Bitte loggen Sie sich ein um diese Funktion zu nutzen.</p>
        </IonRow>
      </>
    );
  }
  /* FULL WIDTH MOBILE MAP */
  const handlefullWidthMap = () => {
    let mapWrapper = document.querySelector(".search__maps");
    mapWrapper.classList.toggle("fullwidth");
  };

  return isLoaded && isPro ? (
    <IonPage
      className={`${isLoggedIn ? "is-logged-in" : "not-logged-in"} ${
        isPro ? "is-pro" : "not-pro"
      }`}
    >

      <ModalBookmark
          isLoggedInValue={isLoggedIn}
          isProValue={isPro}
          pid={pid}
          bookmark={bookmark}
          setbookmark={setbookmark}
          token={token}
      />

      <IonContent fullscreen>
        <IonAlert
          isOpen={showNoResultsAlert}
          onDidDismiss={() => setShowNoResultsAlert(false)}
          header="Leider keine passenden Stellplätze"
          message="Auf dieser Route gab es mit Ihrer Filterauswahl keine Treffer. Kein Problem – wir haben die Filter für Sie zurückgesetzt. Bitte starten Sie eine neue Suche. "
          buttons={['OK']}
          cssClass="custom-alert-width"
        />
        
        {(function () {
          if (mode === "customroute") {
            return (
              <RouteSearch
                getCustomRoute={getCustomRoute}
                pid={pid}
                token={token}
              ></RouteSearch>
            );
          }
        })()}
        <IonButton
                    shape="round"
                    color="primary"
                    id="fullWidthMap"
                    onClick={() => handlefullWidthMap()}
                    className="fullWidthMap"
                  >
                    <IonIcon icon={scanOutline} color="light" />
                  </IonButton>

        <IonGrid>
          <IonRow>
            <IonCol className="search__maps" size="12" size-md="6" size-lg="8">
              <div style={{ display: "flex", height: "100%" }}>
                <Wrapper
                  apiKey={"AIzaSyA_F83EK6cz_LUYSGUSCdcmLDZja7Dk0ho"}
                  render={render}
                >
                  <Map {...mapProps}>
                    {(() => {
                      if (items.length > 0 && (initialDataLoaded || mode === "bookmarkroute")) {
                        return items.map((item) => {
                          return (
                            <Markerroute
                              key={item.id}
                              position={{
                                lat: parseFloat(item.gps.latitude),
                                lng: parseFloat(item.gps.longitude),
                              }}
                              id={item.id}
                              name={item.stellplatzname}
                              marker={item.stellplatztyp}
                            />
                          );
                        });
                      }
                      return null;
                    })()}
                  </Map>
                </Wrapper>
              </div>
            </IonCol>
            <IonCol
              className="search__infocard"
              size="12"
              size-md="6"
              size-lg="4"
            >

              {(initialDataLoaded || mode === "bookmarkroute") && (
                <Filter
                  isLoggedInValue={isLoggedIn}
                  isProValue={isPro}
                  dogValue={dog}
                  setDog={setDog}
                  disposalValue={disposal}
                  setDisposal={setDisposal}
                  forfreeValue={forfree}
                  setForfree={setForfree}
                  sendSearch={sendSearch}
                  versorgung={Constants.versorgung}
                  austattung={Constants.austattung}
                  underground={Constants.underground}
                  interests={Constants.interests}
                  interestsCat={interestsCat}
                  activeFilter={activeFilter}
                  setActiveFilter={setActiveFilter}
                  initialRendered={initialRendered}
                  fireSearch={fireSearch}
                  filterIsSet={filterIsSet}
                  defaultValueFilter={Constants.routeDefaultValueFilter}
                  loading={loading}
                  showNoResults={showNoResults}
                  setShowNoResults={setShowNoResults}
                  onMinimalDataUpdate={(newMinimalData) => {
                    setMinimalData(newMinimalData);
                    window.minData = newMinimalData;
                    
                    if (mode === "customroute" && currentRoutePoints && newMinimalData) {
                      findAndFetchRouteMarkers(
                        currentRoutePoints,
                        newMinimalData,
                        15,
                        (fetchedItems) => {
                          setShowNoResults(fetchedItems.length === 0);
                          setItems(fetchedItems);
                        },
                        (error) => {
                          //console.log("Error recalculating route markers:", error);
                        }
                      );
                    }
                  }}
                />
              )}


              {items.map((item) => {
                if (
                  typeof item.features === "undefined" ||
                  item.features === null
                ) {
                  item.features = {
                    feature: [],
                  };
                }

                var fav = false;
                if (allbookmarks.indexOf(item.id) !== -1) {
                  fav = true;
                }

                if (typeof item.place === "undefined") {
                  item.place = { maxLengthOfPitches: "" };
                }
                if (typeof item.search === "undefined") {
                  item.search = { price: "" };
                }
                if (typeof item.basicCosts === "undefined") {
                  item.basicCosts = { currency: "" };
                }
                if (typeof item.vouchers === "undefined") {
                  item.vouchers = { voucher: [] };
                }
                if (typeof item.prices === "undefined") {
                  item.prices = { generalPrice: "" };
                }

                return (
                  <>
                    <InfoCard
                      key={item.id}
                      id={item.id}
                      slug={item.slug}
                      name={item.stellplatzname}
                      url={item.mainimage}
                      description={item.description}
                      latitude={parseFloat(item.gps.latitude)}
                      longitude={parseFloat(item.gps.longitude)}
                      distance={parseFloat(item.distance)}
                      stellplaetzeLaenge={item.place.maxLengthOfPitches}
                      vergleichspreis={item.search.price}
                      preiseWaehrung={item.basicCosts.currency}
                      voucher={item.vouchers.voucher}
                      ausstattung={item.features.feature}
                      premium={item.premium}
                      fav={fav}
                      city={item.city}
                      country={item.countryName}
                      responseType={searchType}
                      stellplatztyp={item.stellplatztyp}
                      entsorgungsstation={item.entsorgungsstation}
                      interests={profileInterests}
                      category={item.category}
                      subcategories={item.subcategories}
                      interesttags={item.tags}
                      labelpreis={item.prices.generalPrice}
                    />
                  </>
                );
              })}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  ) : (
    <></>
  );
}

export default Route;
